import React from 'react'
const icon = ({ className, isSelected, onClick }) => (

    <svg onClick={onClick} width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8334 28.5006L28.5 11.834" stroke="#DB1B1B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M28.5 28.5006L11.8334 11.834" stroke="#DB1B1B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.1667 39.3333C30.7521 39.3333 39.3333 30.7521 39.3333 20.1667C39.3333 9.58121 30.7521 1 20.1667 1C9.58121 1 1 9.58121 1 20.1667C1 30.7521 9.58121 39.3333 20.1667 39.3333Z" stroke="#DB1B1B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
)
export default icon